import { render, staticRenderFns } from "./JobBoardFormJobSection.vue?vue&type=template&id=54f292ed&scoped=true&"
import script from "./JobBoardFormJobSection.vue?vue&type=script&lang=ts&"
export * from "./JobBoardFormJobSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f292ed",
  null
  
)

export default component.exports